module.exports = "../static/media/banner.6692e245.png";